import { DatePicker } from './menus/DatePicker';
import { OptionsPicker } from './menus/OptionsPicker';
import type { DropdownMenuProps } from './types';

/**
 * A dropdown menu component for selecting options or dates.
 *
 * @example
 * // Options mode
 * <DropdownMenu
 *   options={[
 *     { value: '1', label: 'Option 1' },
 *     { value: '2', label: 'Option 2' },
 *   ]}
 *   value="1"
 *   onChange={(val) => console.log(val)}
 * />
 *
 * @example
 * // Date picker mode
 * <DropdownMenu
 *   datePicker
 *   dateValue={date}
 *   onDateChange={setDate}
 *   placeholder="Select date"
 * />
 *
 * @example
 * // Date range picker mode
 * <DropdownMenu
 *   datePicker
 *   datePickerMode="range"
 *   dateValue={dateRange}
 *   onDateChange={setDateRange}
 *   placeholder="Select range"
 * />
 */
export const DropdownMenu = <T extends string | number = string | number>(props: DropdownMenuProps<T>) => {
    // Handle date picker mode
    if (props.datePicker) return <DatePicker {...props} />;

    // prepare props for OptionsPicker
    const { datePicker: _datePicker, open: controlledOpen, ...restProps } = props;

    return <OptionsPicker controlledOpen={controlledOpen} {...restProps} />;
};

DropdownMenu.displayName = 'DropdownMenu';
